import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
    landing_stat_1_value: "40+",
    landing_stat_1_label: "Vendor categories",
    landing_stat_2_value: "$0",
    landing_stat_2_label: "Cost for hosts",
    landing_stat_3_value: "<10m",
    landing_stat_3_label: "To publish your event",
};

let cache = null;
let inFlight = null;
const listeners = new Set();

const load = async () => {
    if (cache) return cache;
    if (inFlight) return inFlight;
    inFlight = api.get("/site/content")
        .then((res) => {
            cache = { ...DEFAULTS, ...(res.data || {}) };
            listeners.forEach((fn) => fn(cache));
            return cache;
        })
        .catch(() => {
            cache = { ...DEFAULTS };
            listeners.forEach((fn) => fn(cache));
            return cache;
        })
        .finally(() => { inFlight = null; });
    return inFlight;
};

export const useSiteContent = () => {
    const [content, setContent] = useState(cache || DEFAULTS);
    useEffect(() => {
        let mounted = true;
        const onUpdate = (next) => { if (mounted) setContent(next); };
        listeners.add(onUpdate);
        load();
        return () => { mounted = false; listeners.delete(onUpdate); };
    }, []);
    return content;
};

export const refreshSiteContent = async () => {
    cache = null;
    await load();
};
